var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "basic-legend-item" }, [
    _c("div", [
      _vm.layer.allow_control
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.checkboxState,
                expression: "checkboxState",
              },
            ],
            staticClass: "legend-checkbox",
            attrs: { type: "checkbox", id: _vm.layer.layer_name },
            domProps: {
              checked: Array.isArray(_vm.checkboxState)
                ? _vm._i(_vm.checkboxState, null) > -1
                : _vm.checkboxState,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.checkboxState,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.checkboxState = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.checkboxState = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.checkboxState = $$c
                }
              },
            },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("img", { attrs: { src: _vm.layer.legend_graphic, alt: "" } }),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("label", { attrs: { for: _vm.layer.layer_name } }, [
        _vm._v(_vm._s(_vm.layer.layer_name_display)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }